import React, { Component } from "react";

//Import CSS
import "./otica-management.css";
//Import internal components
import { updateRole, createMultiContas } from "../service/multi-contas/multi-contas-service";

//Import external components
import { ExpandMore, Visibility, Create, Delete } from "@material-ui/icons";
import { Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import Input from "../components/inputs/input";
import CustomButton from "../components/buttons/button";
import { Button } from "react-bootstrap";
import AppContext from "../appContext";
import Swal from "sweetalert2";
import Logout from "../main/header/logout";
import UploadLogoOtica from "../main/upload-logo-otica/upload-logo-otica";
//Import image

class OticaManagementRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: "",
      otica: "",
      apelido: "",
      perfil: "",
      cnpj: "",
      principal: "",
      isChangeApelido: false,
      semMultiConta: false,
      nomePrincipal: "",
      tipo_cnpj: "",
    };

    OticaManagementRow.contextType = AppContext;

    this.handleChange = this.handleChange.bind(this);
  }

  handleRemove(id, nome, principal, cnpj) {
    Swal.fire({
      html: "Você está se desvinculando da empresa " + nome + ". <br> Deseja continuar?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim!",
      cancelButtonText: "Não",
    }).then(result => {
      if (result.value) {
        if (principal) {
          this.removePrincipal(cnpj);
        } else {
          this.props.desativarMultiOticas(id);
        }
      }
    });
  }

  updatePrincipal(id, nome, papel, cnpj) {
    Swal.fire({
      html: "Você está tornando a empresa " + nome + ", sua conta principal. <br> Deseja continuar?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim!",
      cancelButtonText: "Não",
    }).then(result => {
      if (result.value) {
        this.updatePrincipalService(id, papel, cnpj);
      }
    });
  }

  logoutExterno(e) {
    const logout = this.refs.logout.refs.logout;

    this.context.showLoading("");
    //TK-083-000230 - Redirecionamento p/ página de login
    setTimeout(() => {
      logout.click();
    }, 100);

    window.scrollTo({ top: 0 });
    this.context.hideLoading();
  }

  updatePrincipalService(id, papel, cnpj) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify({
        idNovaPrincipal: id,
        idUsuario: this.context.user_id,
        cnpj: cnpj,
        papel: papel,
      }),
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("session_token"),
      }),
    };

    fetch(process.env.REACT_APP_LABS_API + "update_multi_conta_principal.php", requestOptions)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.success) {
          Swal.fire({
            text: json.message + " Realize o login novamente para que as alterações sejam salvas.",
            icon: "success",
            title: "Pronto!",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: "#00518b",
            confirmButtonText: "Ok!",
          }).then(result => {
            if (result.value) {
              this.logoutExterno();
            }
          });
        } else {
          Swal.fire({
            text: json.message,
            icon: "error",
            title: "Aviso!",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: "#00518b",
            confirmButtonText: "Ok!",
          });
        }

        this.context.hideLoading();
      });
  }

  handleChange(e) {
    const { name, value } = e.target;

    if (name === "apelido") {
      var nome = value ? value : this.props.item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
      this.setState({ nomePrincipal: nome });
    }

    this.setState({ [name]: value });
  }

  componentDidMount() {
    const { item } = this.props;

    if (item.perfil === "Proprietário de Óptica" || item.perfil === "Gerente de Óptica") {
      this.setState({ isChangeApelido: true });
    }

    this.setState(
      {
        id: item.id,
        nome: item.nome ?? "Empresa sem nome",
        cnpj: item.cnpj,
        perfil: item.perfil,
        apelido: item.apelido,
        principal: item.principal,
        ativo: item.principal,
        desativado: !item.ativo,
        semMultiConta: item.semMultiConta,
      },
      () => {
        var nome = this.props.item.apelido ? this.state.apelido : this.props.item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        this.setState({ nomePrincipal: nome });
      },
    );
  }

  criarMultiContas(callback) {
    this.context.showLoading();
    var cnpj = this.state.cnpj
      .replace(/[^0-9]/g, "")
      .replace("/", "")
      .replace("-", "");

    const body = {
      email: this.context.userSession.email,
      cnpj: cnpj,
      papel: "Novo Usuário Óptica",
      idUsuario: this.context.user_id,
    };

    createMultiContas(body).then(response => {
      this.context.hideLoading();
      if (response.status === 201 || response.status === 200) {
        callback();
      } else {
        Swal.fire({
          text: response.message,
          icon: "warning",
          title: "Aviso!",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonColor: "#00518b",
          confirmButtonText: "Ok!",
        }).then(result => {
          if (result.value) {
          }
        });
      }
    });
  }

  updateApelidoService() {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify({
        cnpj: this.state.cnpj,
        apelido: this.state.apelido,
        onlyApelido: true,
        onlyLabs: false,
      }),
    };

    fetch(process.env.REACT_APP_LABS_API + "update_optics.php", requestOptions)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.success) {
          Swal.fire({
            text: "Apelido alterado com sucesso!",
            icon: "success",
            title: "Pronto!",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: "#00518b",
            confirmButtonText: "Ok!",
          });
        } else {
          Swal.fire({
            text: json.message,
            icon: "error",
            title: "Aviso!",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: "#00518b",
            confirmButtonText: "Ok!",
          });
        }

        this.context.hideLoading();
      });
  }

  updateApelido(semMultiConta) {
    this.updateApelidoService();

    // if (semMultiConta) {
    //     this.criarMultiContas(this.updateApelidoService);
    // } else {
    //     this.updateApelidoService();
    // }
  }

  obterTipoCnpj = (cnpj, callback) => {
    // this.setState({ tipo_cnpj: this.context.userSession.papelCategoria }, callback)
    const requestOptions3 = {
      method: "POST",
      body: JSON.stringify({ cnpj: cnpj }),
    };

    fetch(process.env.REACT_APP_LABS_API + "get_account_data.php", requestOptions3)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.status === 200) {
          if (
            !json.tipo ||
            json.tipo.includes("REDE") ||
            json.tipo.includes("BALCONISTA") ||
            json.tipo.includes("OTICA") ||
            json.tipo.includes("FORNECEDOR") ||
            json.tipo.includes("CONSUMIDORES") ||
            json.tipo.includes("DISTRIBUIDOR")
          ) {
            this.setState({ tipo_cnpj: "OTICA" }, callback);
          } else if (json.tipo === "AFILIADOS" || json.tipo.includes("EMPREGADOS")) {
            this.setState({ tipo_cnpj: "ESSILOR" }, callback);
          } else if (json.tipo.includes("LAB PARTICIPACAO")) {
            this.setState({ tipo_cnpj: "LABORATORIO" }, callback);
          } else if (json.tipo.includes("LAB ALLIANCE") || json.tipo.includes("LABORATORIOS")) {
            this.setState({ tipo_cnpj: "LAB_INDEPENDENTE" }, callback);
          } else if (json.tipo.includes("MEDICO") || json.tipo.includes("CLINICAS")) {
            this.setState({ tipo_cnpj: "MEDICO" }, callback);
          }
        } else {
          this.cnpjNaoEncontrado();
        }
      });
  };

  cnpjNaoEncontrado = () => {
    Swal.fire({
      text: "CNPJ não encontrado.",
      icon: "warning",
      title: "Aviso",
      confirmButtonColor: "#00518b",
      customClass: {
        confirmButton: "x-follow-order__filter-btn",
      },
    });
  };

  removePrincipal(cnpj) {
    this.context.showLoading();
    this.obterTipoCnpj(cnpj, () => {
      updateRole(
        this.context.user_id,
        true,
        this.state.tipo_cnpj,
        cnpj,
        () => {
          this.context.hideLoading();
          Swal.fire({
            text: "Informações atualizadas com sucesso! Realize o login novamente para que as alterações sejam salvas.",
            icon: "success",
            title: "Pronto!",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: "#00518b",
            confirmButtonText: "Ok!",
          }).then(result => {
            if (result.value) {
              this.logoutExterno();
            }
          });
        },
        () => {
          this.context.hideLoading();
        },
      );
    });
  }

  render() {
    return (
      <>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <div className="AccordionSummary row oticaUp">
              <div className="col-12 col-md-2 text-center">
                <UploadLogoOtica cnpj={this.props.item.cnpj} imgCircle={true} />
              </div>
              <div className="col-12 col-md-6 justify-content-center align-self-center">
                <span>{this.state.nomePrincipal}</span>
              </div>
              <div className="col-4 d-none d-md-block justify-content-center align-self-center">
                <span className="float-end">Mais Detalhes</span>
              </div>
            </div>
          </AccordionSummary>

          <AccordionDetails>
            <div className="AccordionSummary row">
              <div className="col-12 col-md-8 profileInput">
                <Input label="Empresa" width="100%" type="text" name="otica" value={this.state.nome} disabled={true} readOnly={true} />
              </div>
              <div className="col-12 col-md-4 profileInput">
                <Input
                  label="CNPJ"
                  width="100%"
                  type="text"
                  name="otica"
                  value={this.state.cnpj?.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") || ""}
                  disabled={true}
                  readOnly={true}
                />
              </div>
            </div>
            <div className="AccordionSummary row">
              <div className="col-12 col-md-6 profileInput">
                <Input label="Perfil" width="100%" type="text" name="perfil" value={this.state.perfil} disabled={true} readOnly={true} />
              </div>
              {this.context.userSession.papelCategoria === "OTICA" && (
                <>
                  <div className="col-12 col-md-6 profileInput">
                    <Input
                      label="Apelido"
                      width="100%"
                      type="text"
                      name="apelido"
                      value={this.state.apelido}
                      onChange={this.handleChange}
                      disabled={true}
                      placeholder="Empresa sem apelido"
                    />
                  </div>
                  {/* {this.state.isChangeApelido && (
                                        <div className="col-12 col-md-4">
                                            <CustomButton
                                                label="Alterar Apelido"
                                                width="100%"
                                                orange_button={true}
                                                onClick={() => this.updateApelido(this.state.semMultiConta)}
                                            />
                                        </div>
                                    )} */}
                </>
              )}
              <div className="col-12 col-md-12 text-center">
                <div className="row">
                  <div className="col-6">
                    {this.state.principal ? (
                      <></>
                    ) : (
                      <Button
                        variant="link"
                        className="btnRemover"
                        onClick={() => this.updatePrincipal(this.state.id, this.state.nome, this.state.perfil, this.state.cnpj)}>
                        <small>Tornar principal</small>
                      </Button>
                    )}
                  </div>

                  <div className="col-6 text-end float-end">
                    <Button
                      variant="link"
                      className="btnRemover"
                      onClick={() => this.handleRemove(this.state.id, this.state.nome, this.state.principal, this.state.cnpj)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 25.022 25">
                        <g id="np_block_2995429_000000" transform="translate(-4.921 -5.712)">
                          <path
                            id="Path_61"
                            data-name="Path 61"
                            d="M4.922,18.21a12.477,12.477,0,0,0,2.271,7.178A12.815,12.815,0,0,0,13.265,30a12.571,12.571,0,0,0,13.769-3.786,12.75,12.75,0,0,0,2.875-7.156,12.481,12.481,0,0,0-7.228-12.2,12.79,12.79,0,0,0-7.833-.888A12.554,12.554,0,0,0,5.1,16.145a15.17,15.17,0,0,0-.177,2.065,1.388,1.388,0,1,0,2.776,0c0-.283.011-.571.034-.854.011-.139.022-.283.039-.422.011-.105.055-.306-.016.105.016-.1.028-.2.044-.3a10.73,10.73,0,0,1,.395-1.6c.083-.261.178-.511.283-.767s-.117.261-.039.094c.028-.055.05-.111.078-.167.061-.133.123-.267.189-.4a11.2,11.2,0,0,1,.872-1.438c.073-.1.144-.194.217-.294-.272.388.005,0,.078-.089.178-.217.366-.422.561-.621s.377-.377.577-.555c.089-.083.183-.16.272-.239.055-.044.111-.094.167-.139.183-.144.066-.039-.05.039.466-.317.911-.644,1.4-.916.228-.123.455-.239.689-.344.055-.028.111-.05.167-.078.256-.117-.322.128-.061.022.139-.055.278-.111.416-.16a11.05,11.05,0,0,1,1.621-.45c.139-.028.272-.05.411-.073.061-.011.128-.016.189-.028.189-.028-.383.044-.105.016.306-.034.616-.061.922-.073a11.615,11.615,0,0,1,1.7.073c.288.028-.35-.055-.066-.011.061.011.128.016.189.028.139.022.272.05.411.073.283.055.561.128.838.2.249.073.5.15.744.239.139.05.278.105.416.16.089.034.211.117-.128-.055.089.044.178.078.267.123a11.159,11.159,0,0,1,1.4.783c.222.144.433.311.655.461-.377-.267-.028-.016.061.055.123.1.239.2.356.311A11.828,11.828,0,0,1,25.032,12.1c.066.078.322.445.055.061.083.117.172.233.261.35.155.217.3.445.438.672s.267.466.388.7c.055.111.111.222.16.333.034.066.061.133.089.2.111.239-.128-.333-.011-.028a12.484,12.484,0,0,1,.511,1.593c.066.272.117.544.16.816.005.05.016.1.022.15.044.288-.039-.356-.011-.066.016.155.034.306.044.461a11.314,11.314,0,0,1-.005,1.788c-.011.128-.028.256-.039.383-.028.288.055-.35.011-.066-.005.05-.016.1-.022.15-.05.3-.105.594-.178.888A11.623,11.623,0,0,1,26.4,22.04c-.105.261.139-.317.022-.061-.034.066-.061.133-.089.2-.05.111-.105.222-.16.333-.133.261-.272.516-.427.767-.128.2-.261.411-.4.61-.083.117-.172.233-.261.35.272-.388-.022.028-.1.117a11.351,11.351,0,0,1-1.11,1.149c-.111.094-.217.194-.333.283-.089.073-.438.317-.061.055-.239.167-.472.344-.716.505a10.642,10.642,0,0,1-1.41.772c-.066.028-.139.055-.2.089.011-.005.333-.139.128-.055-.139.055-.278.111-.416.16-.256.094-.516.178-.777.249s-.533.139-.8.194c-.123.022-.249.05-.372.066l-.228.034c-.249.039.377-.044-.011,0a11.637,11.637,0,0,1-1.7.061c-.283-.011-.566-.039-.844-.066-.228-.022.128.016.144.022l-.228-.034c-.15-.022-.3-.05-.45-.083a10.808,10.808,0,0,1-1.655-.472l-.344-.133c-.261-.105.317.139.061.022-.044-.022-.089-.039-.133-.061-.267-.123-.527-.256-.788-.4-.472-.261-.9-.571-1.343-.877.388.272-.028-.028-.117-.1s-.183-.155-.272-.239c-.217-.194-.427-.395-.628-.605-.167-.178-.327-.356-.483-.544-.073-.089-.377-.505-.1-.117-.083-.117-.172-.233-.261-.35A11,11,0,0,1,8.7,22.5c-.066-.133-.128-.261-.189-.4-.022-.044-.039-.089-.061-.133-.117-.256.128.322.022.061-.111-.278-.211-.555-.306-.838a11.256,11.256,0,0,1-.383-1.61c-.011-.078-.022-.15-.034-.228.066.4.028.233.022.144-.016-.155-.034-.306-.044-.461-.022-.283-.034-.571-.034-.854A1.4,1.4,0,0,0,6.309,16.8,1.452,1.452,0,0,0,4.921,18.21Z"
                            fill="#0394db"
                          />
                          <path
                            id="Path_62"
                            data-name="Path 62"
                            d="M32.9,17.906l-1.566,1.566L27.573,23.23l-4.547,4.547L19.1,31.707c-.639.639-1.288,1.26-1.909,1.909l-.028.028a1.389,1.389,0,0,0,1.965,1.965l1.566-1.566,3.758-3.758,4.547-4.547,3.931-3.931c.639-.639,1.288-1.26,1.909-1.909l.028-.028A1.389,1.389,0,0,0,32.9,17.906Z"
                            transform="translate(-8.551 -8.522)"
                            fill="#0394db"
                          />
                        </g>
                      </svg>
                      <small className="ms-2">Sair da empresa</small>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
        <div className="d-none">
          <Logout ref="logout" />
        </div>
      </>
    );
  }
}

export default OticaManagementRow;
